// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MediaBubble__container-a81bcd:hover .MediaBubble__status-bar-b3095e {
  opacity: 1;
}

.MediaBubble__bubble-b8ebee {
  display: flex;
  justify-content: center;
  flex-direction: column;
  max-width: var(--message-bubble-max-width);
  padding: 0;
}

.MediaBubble__content-fb7749 {
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.MediaBubble__status-bar-b3095e {
  position: absolute;
  inset-inline-end: 8px;
  bottom: 8px;
  border-radius: 20px;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 4px 8px;
  opacity: 0;
  transition: opacity 0.15s ease-in-out;
}

.MediaBubble__status-bar-b3095e > span {
  color: var(--addition-50);
}

.MediaBubble__status-bar-b3095e > svg {
  fill: var(--addition-50);
  color: var(--danger-40);
}

.MediaBubble__comment-e04b88 {
  padding: 10px 12px;
  color: var(--base-110);
}

.MediaBubble__comment-text-f95c64 {
  display: inline;
}

.MediaBubble__commented-status-bar-e5ac9b {
  float: right;
  margin-top: 2px;
  margin-inline-start: var(--indent-8px);
}

.MediaBubble__views-c3e259 span {
  color: var(--addition-50);
}

.MediaBubble__views-c3e259 svg {
  fill: var(--addition-50);
}

.MediaBubble__thread-button-ef6dae {
  margin: 10px -12px -10px -12px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/bubbles/MediaBubble/MediaBubble.styles.m.css"],"names":[],"mappings":"AAAA;EACE,UAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,0CAAA;EACA,UAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;AACF;;AAEA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,mBAAA;EACA,oCAAA;EACA,gBAAA;EACA,UAAA;EACA,qCAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,wBAAA;EACA,uBAAA;AACF;;AAEA;EACE,kBAAA;EACA,sBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,YAAA;EACA,eAAA;EACA,sCAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,8BAAA;AACF","sourcesContent":[".container:hover .status-bar {\n  opacity: 1;\n}\n\n.bubble {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  max-width: var(--message-bubble-max-width);\n  padding: 0;\n}\n\n.content {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.status-bar {\n  position: absolute;\n  inset-inline-end: 8px;\n  bottom: 8px;\n  border-radius: 20px;\n  background-color: rgba(0, 0, 0, 0.7);\n  padding: 4px 8px;\n  opacity: 0;\n  transition: opacity 0.15s ease-in-out;\n}\n\n.status-bar > span {\n  color: var(--addition-50);\n}\n\n.status-bar > svg {\n  fill: var(--addition-50);\n  color: var(--danger-40);\n}\n\n.comment {\n  padding: 10px 12px;\n  color: var(--base-110);\n}\n\n.comment-text {\n  display: inline;\n}\n\n.commented-status-bar {\n  float: right;\n  margin-top: 2px;\n  margin-inline-start: var(--indent-8px);\n}\n\n.views span {\n  color: var(--addition-50);\n}\n\n.views svg {\n  fill: var(--addition-50);\n}\n\n.thread-button {\n  margin: 10px -12px -10px -12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MediaBubble__container-a81bcd`,
	"status-bar": `MediaBubble__status-bar-b3095e`,
	"statusBar": `MediaBubble__status-bar-b3095e`,
	"bubble": `MediaBubble__bubble-b8ebee`,
	"content": `MediaBubble__content-fb7749`,
	"comment": `MediaBubble__comment-e04b88`,
	"comment-text": `MediaBubble__comment-text-f95c64`,
	"commentText": `MediaBubble__comment-text-f95c64`,
	"commented-status-bar": `MediaBubble__commented-status-bar-e5ac9b`,
	"commentedStatusBar": `MediaBubble__commented-status-bar-e5ac9b`,
	"views": `MediaBubble__views-c3e259`,
	"thread-button": `MediaBubble__thread-button-ef6dae`,
	"threadButton": `MediaBubble__thread-button-ef6dae`
};
module.exports = ___CSS_LOADER_EXPORT___;
